// extracted by mini-css-extract-plugin
export default {"root":"FormGroup_root__qZUR2","header":"FormGroup_header__1shhZ","title":"FormGroup_title__gf+1t","body":"FormGroup_body__JAFpX"};